import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import configData from "config.json"
import { authHeaderWithToken } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { InformacionHojaVida } from "./typesGenerarHojaVida";




export async function ObtenerPdfHojaVida(){
    var resultado:ResponseRequest = {status:200};
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVida`;
    var userData:UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA,{
            headers:authHeaderWithToken(userData.token),
            responseType:"blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status:200,
            dataResponse: urlPDF
        }
           
    } catch (error) {
        var mensaje:string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if(axios.isAxiosError(error) && error.response){            

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if(mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")){
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage:mensaje
            }
        }        
    }
    return resultado;



}

export async function ObtenerInformacionHojaVida(handleError:()=>void){
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Informacion/UltimaHojadeVidaGenerada`;
    var userData:UserData = authenticationService.currentUserValue;
    var datos:InformacionHojaVida|undefined = undefined;


    try {
        const respuesta = await axios.get(URL_HOJA_VIDA,{
            headers:authHeaderWithToken(userData.token),
        })

       datos = respuesta.data;
           
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            ;
        }
        handleError();
    }
    return datos;

}

export async function ObtenerPdfHojaVidaAcreditacionEURACE() {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaAcreditacionEURACE`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_EURACE.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaConsultorAcreditacionEURACE(idpersona) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorAcreditacionEURACE/${idpersona}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_EURACE.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaConsultor(idpersona) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultor/${idpersona}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerExcelHojaVidaConsultorAcreditacionEURACE(idunidad) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorExcelAcreditacionEURACE/${idunidad}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "reporte_excel_EURACE.xlsx"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de generar el reporte excel";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerWordHojaVidaAcreditacionEURACE() {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaWordAcreditacionEURACE`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_EURACE.docx"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaUnidadAcreditacionEURACE_docente(idunidad) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorUnidadAcreditacionEURACEDocente/${idunidad}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_unidad_EURACE_docente.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaUnidadAcreditacionEURACE_administrativo(idunidad) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorUnidadAcreditacionEURACEAdministrativo/${idunidad}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_unidad_EURACE_administrativo.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaAcreditacionAACSB(idioma) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaAcreditacionAACSB/${idioma}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_ACBSP.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaConsultorAcreditacionAACSB(idpersona, idioma) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorAcreditacionAACSB/${idpersona}/${idioma}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_ACBSP.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaConsultorAcreditacionABET(idpersona, idioma) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorAcreditacionABET/${idpersona}/${idioma}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_ABET.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaUnidadAcreditacionAACSB_grado(idunidad, idioma) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorUnidadAcreditacionAACSBgrado/${idunidad}/${idioma}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_unidad_ACBSP_grado.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaUnidadAcreditacionAACSB_posgrado(idunidad, idioma) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorUnidadAcreditacionAACSBposgrado/${idunidad}/${idioma}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_unidad_ACBSP_posgrado.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaUnidadAcreditacionAACSB_docentes(idunidad, idioma) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorUnidadAcreditacionAACSBdocentes/${idunidad}/${idioma}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_unidad_ACBSP_docentes.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerExcelHojaVidaConsultorAcreditacionAACSB(idunidad) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorExcelAcreditacionAACSB/${idunidad}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "reporte_excel_ACBSP.xlsx"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de generar el reporte excel";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerWordHojaVidaAcreditacionABET() {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaWordAcreditacionABET`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_ABET.docx"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaAcreditacionABET(idioma) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaAcreditacionABET/${idioma}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_ABET.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerExcelHojaVidaConsultorAcreditacionABET(idunidad) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorExcelAcreditacionABET/${idunidad}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "reporte_excel_ABET.xlsx"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de generar el reporte excel";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}

export async function ObtenerPdfHojaVidaUnidadAcreditacionABET(idunidad, idioma) {
    var resultado: ResponseRequest = { status: 200 };
    var urlPDF = "";
    const URL_HOJA_VIDA = `${configData.SERVER_URL}FormularioController/Descargar/HojadeVidaConsultorUnidadAcreditacionABET/${idunidad}/${idioma}`;
    var userData: UserData = authenticationService.currentUserValue;
    try {
        const respuesta = await axios.get(URL_HOJA_VIDA, {
            headers: authHeaderWithToken(userData.token),
            responseType: "blob"
        })

        const respuestaBlob = new Blob([respuesta.data]);
        let url = window.URL.createObjectURL(respuestaBlob);
        urlPDF = url;
        let a = document.createElement('a');
        a.href = url;
        a.download = "hojaVida_unidad_ABET.pdf"  //nombrearchivo
        a.click()
        resultado = {
            status: 200,
            dataResponse: urlPDF
        }

    } catch (error) {
        var mensaje: string = "Ha ocurrido un inconveniente al tratar de Generar la Hoja de Vida";
        if (axios.isAxiosError(error) && error.response) {

            mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            if (mensaje.includes("Complete/Actualice su información de datos personales para generar la hoja de vida")) {
                mensaje = "Complete su información de datos personales para generar la hoja de vida."
            }
            resultado = {
                status: error.response.status,
                errorMessage: mensaje
            }
        }
    }
    return resultado;
}